import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';


function parseJwt (token: string) {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

const AuthService = {
  checkAccessTokenService: async () => {
    const url = apiPath.SITE_ONTOLOGY_LEVELS_URL;
    try {
      const apiRes = await axiosClient.get(url);
      const res = apiRes.data;
      return {
        status: 'success',
        res,
      };
    } catch (error) {
      return {
        status: 'error',
        error,
      };
    }
  },

  loginService: async (payload: { username: string; password: string }) => {
    // const url = `/check_token/${token}`;
    // console.log(token);
    try {
      // const res = await axiosClient.get(url);
      const params = new URLSearchParams();
      params.append('client_id', 'iot-in-box-ui');
      params.append('username', payload.username);
      params.append('password', payload.password);
      params.append('grant_type', 'password');
      // params.append("permission", "IOT#all")
      //ec2-18-221-154-54.us-east-2.compute.amazonaws.com
      const res = await axiosClient.post(
        `http://${window.location.hostname}/auth/realms/iot_in_box/protocol/openid-connect/token`,
        params,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      // const res = payload;
      // @ts-ignore
      axiosClient.defaults.headers['Authorization'] = 'Bearer ' + res.data.access_token;
      // @ts-ignore
      localStorage.setItem('token', res.data.access_token);
      const jwt = parseJwt(res.data.access_token);
      // console.log(jwt);
      localStorage.setItem('username', jwt.name ?? 'Not updated')
      return {
        status: 'success',
        res: res.data,
      };
    } catch (error) {
      return {
        status: 'error',
        error,
      };
    }
  },
};

export default AuthService;
